<ng-container *ngIf="item$ | async as item">
    <ntap-prime-common-itemview #povijestItemView></ntap-prime-common-itemview>
</ng-container>
